import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Loading from 'uI/Loading/Loading';
// import Landing from 'components/UDCPreregister/Landing/Landing';
import CheckUser from 'components/UDCPreregister/CheckUser/CheckUser';
import GeneralData from 'components/UDCPreregister/GeneralData/GeneralData';
import Payment from 'components/UDCPreregister/Payment/Payment';
import SelectEmail from 'components/UDCPreregister/SelectEmail/SelectEmail';

import { getNewStep } from 'store/preregister-actions';

import classes from './UDCPreregister.module.css';

const UDCPreregister = () => {
  const userInfo = useSelector(state => state.userInfo);
  const [load, setLoad] = useState(true);
  const [stepData, setStepData] = useState({});
  const [idOrder, setIdOrder] = useState('');
  const [emails, setEmails] = useState([]);

  useEffect(() => {
    if (userInfo.data.systemDate) {
      if (userInfo.data.usuario) {
        (async () => {
          setStepData(await getNewStep());
        })();
      } else {
        setLoad(false);
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (stepData.step === 'payment') {
      setIdOrder(stepData.idOrder);
      setLoad(false);
    } else if (stepData.step === 'pre_registered') {
      setEmails(stepData.emailOptions);
      setLoad(false);
    }
  }, [stepData]);

  const reloadInfoHandler = () => {
    (async () => {
      setStepData(await getNewStep());
    })();
  };

  return (
    <>
      {!load ? (
        <div className={classes.container}>
          {stepData.step === 'form_data' ? (
            <GeneralData
              userInfo={userInfo.data}
              programs={stepData.availablePrograms}
              reloadInfo={reloadInfoHandler}
            />
          ) : stepData.step === 'payment' ? (
            <Payment
              idOrder={idOrder}
              userInfo={userInfo.data}
              reloadInfo={reloadInfoHandler}
              program={stepData.availablePrograms.name}
              selectedPlan={stepData.selectedPlan}
            />
          ) : stepData.step === 'pre_registered' ? (
            <SelectEmail emailsData={emails} />
          ) : (
            ''
          )}
          {!userInfo.data.nombre && <CheckUser />}
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default UDCPreregister;
